module.exports = new __parcel__URL__("done-success.c2f2a83f.svg").toString();